module.exports = __webpack_public_path__ + "static/media/Moi.dba9f9b9.png";